import { render } from "./InvalidInvite.vue?vue&type=template&id=d7a1d6e8"
import script from "./InvalidInvite.vue?vue&type=script&lang=js"
export * from "./InvalidInvite.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/staging/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__